import { didApiUrl } from '@/environment';
import { authenticatedAxios } from '@/services/auth';
import { CreateTemplateFormData, IProjectTemplate, UpdateTemplateFormData, VisibilityFilter } from '@d-id/types';
import { AxiosRequestHeaders } from 'axios';

export const createTemplate = async (payload: CreateTemplateFormData): Promise<IProjectTemplate> => {
    const response = await authenticatedAxios?.post(`${didApiUrl}/projects/templates`, payload);
    return response?.data;
};

export const updateTemplate = async (templateId: string, payload: UpdateTemplateFormData): Promise<IProjectTemplate> => {
    const response = await authenticatedAxios?.patch(`${didApiUrl}/projects/templates/${templateId}`, payload);
    return response?.data;
};

export const getTemplates = async (headers: AxiosRequestHeaders, visibility?: VisibilityFilter): Promise<IProjectTemplate[]> => {
    const query = visibility !== VisibilityFilter.VISIBLE ? `?visibility=${visibility}` : '';
    const response = await authenticatedAxios?.get(`${didApiUrl}/projects/templates${query}`, { headers });
    return response?.data;
};
